module.exports = __webpack_public_path__ + "media/images/emblems/Blason_commune_CH_Rennaz_(Vaud)-d956c15fb698dc16d8b30ee348a674d6.svg";